import { render, staticRenderFns } from "./LocalSearchesMailed.vue?vue&type=template&id=0449b454"
import script from "./LocalSearchesMailed.vue?vue&type=script&lang=js"
export * from "./LocalSearchesMailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports